//------------------------------------------------------------------------------
//     This code was generated by a tool.
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
//------------------------------------------------------------------------------  
enum WorkTaskKeyType {

  Listing = 1,

  Reservation = 2,

}

export default WorkTaskKeyType;